import React, { useState } from "react";

const Header = ({sectionRef,is2kView}) => {

  const {journeyRef,awardsRef,expertiseRef,contactRef}=sectionRef;

  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <nav
      className={`z-50 fixed w-full left-0 top-5 px-3 sm:px-5 font-RedHat text-white md:px-30 lg:px-20 xl:px-44 ${is2kView && "2xl:px-80"} `}
    >
      <div className="h-fit py-3 sm:py-4 flex items-center justify-between px-3 sm:px-5 rounded-full"       
        style={{
          background: "#FFFFFF30",
          backdropFilter: "blur(19.2px)",
        }}
      >
        {/* Logo/Title Section */}
        <div className="flex-shrink-0 text-sm sm:text-base lg:text-[1.2rem] font-bold">
          <h2 className="truncate">Dr. C Imthyaz Sheriff</h2>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex flex-row items-center justify-end gap-10 flex-1">
          <ul className="flex flex-row items-center space-x-5">
            <li className="text-center text-[1.2rem] hover:text-primary transition-all duration-300 ease-in-out cursor-pointer">
              <a onClick={() => scrollToSection(journeyRef)}>Journey</a>
            </li>
            <li className="text-center text-[1.2rem] hover:text-primary transition-all duration-300 ease-in-out cursor-pointer">
              <a onClick={() => scrollToSection(awardsRef)}>Awards</a>
            </li>
            <li className="text-center text-[1.2rem] hover:text-primary transition-all duration-300 ease-in-out cursor-pointer">
              <a onClick={() => scrollToSection(expertiseRef)}>Expertise</a>
            </li>
          </ul>
          <a
            onClick={() => scrollToSection(contactRef)}
            className="bg-primary py-2 px-5 text-[1.2rem] rounded-full relative overflow-hidden group cursor-pointer"
          >
            <div className="absolute inset-0 w-0 group-hover:w-full transition-all duration-500 ease-in-out bg-white/20"></div>
            <span className="relative">Contact me</span>
          </a>
        </div>

        {/* Mobile Navigation */}
        <div className="lg:hidden flex items-center gap-2 sm:gap-3">
          {/* Mobile Contact Button */}
          <a
            onClick={() => scrollToSection(contactRef)}
            className="bg-primary py-2 px-3 sm:px-4 text-xs sm:text-sm rounded-full relative overflow-hidden group cursor-pointer whitespace-nowrap"
          >
            <div className="absolute inset-0 w-0 group-hover:w-full transition-all duration-500 ease-in-out bg-white/20"></div>
            <span className="relative">Contact me</span>
          </a>
          
          {/* Hamburger Menu Button */}
          <button 
            onClick={() => setIsOpen(!isOpen)}
            className="text-white focus:outline-none bg-primary p-2 rounded-full flex-shrink-0"
          >
            {isOpen ? (
              <svg
                className="w-5 h-5 sm:w-6 sm:h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                className="w-5 h-5 sm:w-6 sm:h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Menu Overlay */}
        <ul className={`lg:hidden absolute top-16 sm:top-20 right-0 p-4 bg-primary transition-all duration-500 ease-in-out h-[80vh] justify-around z-100 flex-col flex w-64 sm:w-80 transform rounded-xl ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}>
          <li className="text-center text-lg sm:text-xl hover:text-white/80 transition-all duration-300 ease-in-out cursor-pointer">
            <a onClick={() => {scrollToSection(journeyRef); setIsOpen(false)}}>Journey</a>
          </li>
          <li className="text-center text-lg sm:text-xl hover:text-white/80 transition-all duration-300 ease-in-out cursor-pointer">
            <a onClick={() => {scrollToSection(awardsRef); setIsOpen(false)}}>Awards</a>
          </li>
          <li className="text-center text-lg sm:text-xl hover:text-white/80 transition-all duration-300 ease-in-out cursor-pointer">
            <a onClick={() => {scrollToSection(expertiseRef); setIsOpen(false)}}>Expertise</a>
          </li>
          <li className="text-center">
            <a
              onClick={() => {scrollToSection(contactRef); setIsOpen(false)}}
              className="bg-white text-primary py-3 px-6 text-lg rounded-full hover:bg-white/90 transition-all duration-300 ease-in-out cursor-pointer inline-block"
            >
              Contact me
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;